// apps/client/src/assets/builders/bridge.ts — a 4 × 2 plank bridge (DESIGN.md: alternating #C9A274 / #BD9569 planks on trunk-brown
// posts), raised in a gentle arc, with two railings. At rot 0 it spans x (bank, river, river, bank); its ends sit at bank height.
import * as THREE from 'three';
import { RoundedBoxGeometry } from 'three/addons/geometries/RoundedBoxGeometry.js';
import { toyMaterial } from '../../characters/doll';
import type { CodeBuilder } from '../service';

const PLANKS = 9, LENGTH = 4, ARC = 0.12;
/** Deck top above the bank at x ∈ [−2, 2] along the span (0 at the ends). */
export const deckRise = (x: number): number => ARC * Math.sin(Math.PI * Math.min(1, Math.max(0, (x + LENGTH / 2) / LENGTH)));

export const builder: CodeBuilder = {
  id: 'bridge',
  build() {
    const g = new THREE.Group();
    const part = (geo: THREE.BufferGeometry, hex: string, x: number, y: number, z: number, rz = 0) => {
      const m = new THREE.Mesh(geo, toyMaterial(hex));
      m.position.set(x, y, z);
      m.rotation.z = rz;
      m.castShadow = m.receiveShadow = true;
      g.add(m);
      return m;
    };
    const plank = new RoundedBoxGeometry(0.42, 0.1, 1.9, 3, 0.03);
    const pitch = (LENGTH - 0.42) / (PLANKS - 1);
    for (let i = 0; i < PLANKS; i++) {
      const x = -LENGTH / 2 + 0.21 + i * pitch, slope = Math.atan(ARC * Math.PI / LENGTH * Math.cos(Math.PI * (x + LENGTH / 2) / LENGTH));
      part(plank, i % 2 ? '#BD9569' : '#C9A274', x, deckRise(x) - 0.03, 0, slope);
    }
    const post = new RoundedBoxGeometry(0.14, 0.9, 0.14, 3, 0.04);
    for (const x of [-1.9, 1.9]) for (const z of [-0.88, 0.88]) part(post, '#8A6A4F', x, 0.12, z);
    const rail = new RoundedBoxGeometry(3.9, 0.08, 0.08, 2, 0.03);
    for (const z of [-0.88, 0.88]) part(rail, '#8A6A4F', 0, 0.5, z);
    return g;
  },
};
